import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions';
import { connect } from 'react-redux';
import PeoplePicker  from '../../formFields/PeoplePicker';
import { ADD_PMOS } from '../../../actions/types';
import {Icon} from '@fluentui/react';
import { isPMOsValid } from './Validator';
import InfoTooltip from '../../formFields/InfoTooltip';
import Api from '../../../services/Api';

const warningIcon = <div className='warning-inline warning-nolabel'><Icon  iconName="Warning"/></div>

class PMO extends React.Component {
    state = {
        PMOs : []
    }
    componentDidMount() {
        if (this.props.template.config != null) {
            //var  configJson = JSON.parse(this.props.template.config);
            this.getPMO(this.props.template.config.pmoUserId); 
        }
    }

    getPMO(groupId) {
        // Api.get(`/PMO?groupId=${groupId}`)
         Api.get(`/User/GetUserById?userId=${groupId}`)
        .then(res => {
            const PMOs = [res.data];
            this.setState({PMOs});
            this.props.addPMOs(PMOs);
        })
    }

    _onSelectedUser = (items) => {
        this.props.addPMOs(items);
    }

    render() {
        const warning = this.props.possibleWarning && !isPMOsValid()
                        ? warningIcon : null;

        return (
            
            <div className='wizard-inside-third' style={{height: 'unset'}}>
                <div className="item-Owner">
                    PMO
                    <InfoTooltip content='The Project Management Office facilitates the sharing of resources, methodologies, tools and techniques and it is one of the administrators of the team created in this provisioning process. This configuration ensures that the information will always be available for our company, even if all people with access to the team (including other administrators) leave. HIS OWNERSHIP MUST NEVER BE REMOVED from any channel of the team!' />
                </div>
                {warning}
                <PeoplePicker
                    defaultUsers= {this.state.PMOs} 
                    onSelectedUsers={this._onSelectedUser}
                    disabled={true}
                    //itemLimit={1}
                    // errorMessage={error}
                />
            </div>
        );
    }
}

// Approver.propTypes = {
//     addApprover: PropTypes.func.isRequired,
//     approver: PropTypes.object,
//     currentUser: PropTypes.object,
//     manager: PropTypes.object,
//     owner: PropTypes.object,
// }

const mapActionToProp = (dispatch) => ({
    addPMOs: (element) => { dispatch(addElement(ADD_PMOS, element)) }
})

const mapStateToProps  = state => ({
    currentUser: state.user.currentUser,
    PMOs: state.newSite.PMOs,
    possibleWarning : state.wizard.nextStepRequested,
    template : state.newSite.Template
})

export default connect(mapStateToProps, mapActionToProp)(PMO);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/PMO.js